///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../collections/report-employee-categories.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportEmployeeCategoryDataTemplate extends DataTemplateBase implements IDataTemplate {

        private employeeCategories: ReportEmployeeCategoriesCollection;

        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.employeeCategories;
        }

        constructor(model: Dictionary<any> = {}, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.title = 'LABEL_EMPLOYEE_CATEGORIES';
            this.allSelectedLabel = 'LABEL_ALL_EMPLOYEE_CATEGORIES_UPPER';
            this.totalSelectedMessage = 'LABEL_TOTAL_EMPLOYEE_CATEGORIES_SELECTED';

            this.filters = [new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE_EMPLOYEE_CATEGORIES'})];

            this.employeeCategories = new ReportEmployeeCategoriesCollection(model[properties[0]], [], { criteria: options.criteria });
            this.employeeCategories.addFilters(...this.filters as IInteractiveFilter[]);

            if (options != null && !options.required) {
                this.validation.push(
                    new RequiredIfAllUnselectedValidation(
                        this.employeeCategories,
                        () => this.smartMoverHidden,
                        'LABEL_REPORTS_SELECT_AT_LEAST_ONE_EMPL_CATEGORY'
                    )
                );
            }
        }
    }
}